import axios from '@/service/request';
import type { R, ChannelTypeEnum, BuyerOperationTypeEnum } from './types';
import type { MiniLoginResponse } from './buyerWechatLogin';

/**
 * 验证码登录/注册请求参数
 */
export interface MiniCaptchaLoginRequest {
  /** 手机/邮箱 */
  account?: string;
  /** 验证码 */
  captcha?: string;
  /** 登录/注册渠道 */
  channel?: ChannelTypeEnum;
  /** 操作类型 */
  operationType?: BuyerOperationTypeEnum;
}

/**
 * 验证码登录/注册
 */
export const apiBuyerLoginCaptcha = (data: MiniCaptchaLoginRequest): Promise<R<MiniLoginResponse>> => {
  return axios.post('/buyer/login/captcha', data);
};

